import React from 'react'
import Header from '../Component/Header/Header'
import Footer from '../Component/Footer/Footer'
import Main from '../Component/ProjectSections/ProjectsMain'

function Projects() {
  return (
    <>
    <Header/>
    <Main/>
    <Footer/>
    </>
  )
}

export default Projects